import type { PropertyValue } from 'schema-dts';

export function jsonLDProperty(
  name: string,
  value: unknown
): PropertyValue | null {
  return value !== null
    ? { '@type': 'PropertyValue', name, value: `${value}` }
    : null;
}

export function jsonLD<T extends object>(data: T) {
  return {
    'script:ld+json': {
      '@context': 'https://schema.org',
      ...data,
    },
  };
}
